import React, { useEffect, useState, useCallback } from "react";
import Styles from "./PopupForm.module.css";
import Image from "next/image";
import RequestForm from "../RequestForm/RequestForm";
import Link from "next/link";
import ReactDOM from "react-dom";
import { CircleX } from "lucide-react";
import { trackEventPreEnrolment } from "@/services/mixpanel";
import CareerForm from "../CareerForm/CareerForm";

interface PopupFormProps {
  BroutcherLink?: any;
  isVisible: boolean;
  title?: string;
  pageSlug?: any;
  programOfIntrest?: any;
  popupData?: any;

  save_data_on_vinecrm?: boolean;
  thankYouMessageData?: any;
  onClose: () => void;
  redirectlink?: any;
  isProgramPage?: any;
  popUpData?: any;
  preEnrollmentEnable?: boolean;
  buttonLabel?: any;
  careerPopup?: boolean;
  saveEvenCmsData?: boolean;
  saveDataOnVinecrm?: boolean;
  formFieldsSection?: any;
  EventTitle?: string;
  programOfIntrestLP?: any;
  programOfInterestMultipleOptionList?: boolean;
}

const PopupForm: React.FC<PopupFormProps> = ({
  isVisible,
  onClose,
  popupData,

  BroutcherLink,
  programOfIntrest,
  redirectlink,
  isProgramPage,
  popUpData,
  preEnrollmentEnable,
  buttonLabel,
  // thankYouMessageData,
  careerPopup,
  programOfIntrestLP,
  programOfInterestMultipleOptionList,
  saveEvenCmsData,
  saveDataOnVinecrm,
  formFieldsSection,
  EventTitle,
}) => {
  // Debug logging

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [popupClosed, setPopupClosed] = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);

  const [filledFields, setFilledFields] = useState<string[]>([]);

  const handleFilledFieldsChange = useCallback((fields: string[]) => {
    setFilledFields(fields);
  }, []);

  const handleStep = (value: any) => {
    setCurrentStep(value);
  };
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setIsPopupVisible(isVisible);
    document.body.style.overflow = isVisible ? "hidden" : "";

    if (isVisible) {
      trackEventPreEnrolment("lead_form_opened", {
        source: buttonLabel,
      });
    }

    if (isVisible) {
      trackEventPreEnrolment("lead_form_opened", {
        source: buttonLabel,
      });
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isVisible, buttonLabel]);

  useEffect(() => {
    const element = document.createElement("div");
    document.body.appendChild(element);
    setContainer(element);

    return () => {
      document.body.removeChild(element);
    };
  }, []);

  if (!container) return null;

  const closePopup = async () => {
    if (currentStep === 2) {
      await setPopupClosed(true);
    }
    setIsPopupVisible(false);
    onClose();
    if (filledFields) {
      trackEventPreEnrolment("lead_form_abandoned", {
        fields_filled: filledFields.length,
        fields_filled_input: filledFields,
      });
    }
    if (filledFields) {
      trackEventPreEnrolment("lead_form_abandoned", {
        fields_filled: filledFields.length,
        fields_filled_input: filledFields,
      });
    }
    if (filledFields) {
      trackEventPreEnrolment("lead_form_abandoned", {
        fields_filled: filledFields.length,
        fields_filled_input: filledFields,
      });
    }
  };

  const handleFormSubmit = () => {
    setIsSubmitted(true);

    const currentPath = window.location.pathname;

    if (currentPath.startsWith("/lp/")) {
      closePopup();
    } else {
      setShowThankYouMessage(true);
      if (redirectlink) {
        window.location.href = redirectlink;
      }
      setTimeout(() => {
        setShowThankYouMessage(false);
        closePopup();
      }, 4000);
    }
  };

  return ReactDOM.createPortal(
    isVisible && (
      <div
        className={`${Styles.PopupContainer} ${
          isPopupVisible ? Styles.visible : ""
        }`}
        data-section="Popup"
        style={{
          backgroundColor: isPopupVisible ? "rgba(0, 0, 0, 0.5)" : "white",
        }}
      >
        <div
          className={`${isSubmitted ? Styles.thankPopup : Styles.Popup} ${
            isPopupVisible ? Styles.visible : ""
          }`}
        >
          <span className={Styles.CloseButton} onClick={closePopup}>
            <CircleX />
          </span>
          {popUpData?.image_with_redirection ? (
            <Link
              href={popUpData?.image_with_redirection?.link?.url || ""}
              target="_blank"
              title={
                popUpData?.image_with_redirection?.image?.alternativeText ||
                "Popup Image"
              }
            >
              <div className={Styles.Content}>
                <div className={Styles.ImageContaine}>
                  {popUpData?.image_with_redirection?.image && (
                    <div className={Styles.WebImage}>
                      <Image
                        src={
                          popUpData?.image_with_redirection?.image?.url || ""
                        }
                        alt={
                          popUpData?.image_with_redirection?.image
                            ?.alternativeText || "Popup Image"
                        }
                        title={
                          popUpData?.image_with_redirection?.image
                            ?.alternativeText || "Popup Image"
                        }
                        className={Styles.Image}
                        layout="fill"
                        style={{
                          objectFit: "cover",
                        }}
                        loading="eager"
                        priority
                      />
                    </div>
                  )}
                  {popUpData?.image_with_redirection?.mobile_image && (
                    <div className={Styles.MobileImage}>
                      <Image
                        src={
                          popUpData?.image_with_redirection?.mobile_image
                            ?.url || ""
                        }
                        alt={
                          popUpData?.image_with_redirection?.image
                            ?.alternativeText || "Popup Image"
                        }
                        title={
                          popUpData?.image_with_redirection?.image
                            ?.alternativeText || "Popup Image"
                        }
                        layout="fill"
                        style={{
                          objectFit: "cover",
                        }}
                        loading="eager"
                        priority
                      />
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ) : (
            <>
              {!isSubmitted ? (
                <div className={Styles.Content}>
                  <div className={Styles.ImageContainer}>
                    <div className={Styles.WebImage}>
                      <Image
                        src={
                          popUpData?.common_popup?.images[0]?.url ||
                          popUpData?.desktop_img?.url ||
                          popUpData?.PopupDesktop ||
                          popupData?.desktop_image?.url ||
                          popupData?.common_popup?.images[0]?.url ||
                          "/assets/PoupImages/popup-img-desktop.png"
                        }
                        alt={
                          popUpData?.common_popup?.images[0]?.alternativeText ||
                          popUpData?.desktop_img?.alternativeText ||
                          popupData?.desktop_image?.alternativeText ||
                          "Popup Image"
                        }
                        title={
                          popUpData?.common_popup?.images[0]?.alternativeText ||
                          popUpData?.desktop_img?.alternativeText ||
                          popupData?.desktop_image?.alternativeText ||
                          "Popup Image"
                        }
                        className={Styles.Image}
                        width={400}
                        height={580}
                        layout="responsive"
                        style={{
                          objectFit: "cover",
                        }}
                        loading="eager"
                        priority
                      />
                    </div>
                    <div className={Styles.MobileImage}>
                      <Image
                        src={
                          popUpData?.common_popup?.mobile_images?.[0]?.url ||
                          popUpData?.mobile_img?.url ||
                          popUpData?.PopupMobile ||
                          popupData?.mobile_image?.url ||
                          "/assets/PoupImages/popup-img-mobile.png"
                        }
                        alt={
                          popUpData?.common_popup?.mobile_images?.[0]
                            ?.alternativeText ||
                          popUpData?.mobile_image?.alternativeText ||
                          "Popup Image"
                        }
                        title={
                          popUpData?.common_popup?.mobile_images?.[0]
                            ?.alternativeText ||
                          popupData?.desktop_img?.alternativeText ||
                          "Popup Image"
                        }
                        width={560}
                        height={311}
                        layout="responsive"
                        style={{
                          objectFit: "cover",
                        }}
                        loading="eager"
                        priority
                      />
                    </div>
                  </div>
                  <div className={Styles.TextContainer}>
                    {careerPopup ? (
                      <CareerForm
                        onFormSubmit={handleFormSubmit}
                        formTittle={popUpData?.title}
                        formButton={popUpData?.button_label}
                      />
                    ) : (
                      <RequestForm
                        BroutcherLink={BroutcherLink}
                        onFormSubmit={handleFormSubmit}
                        programOfIntrest={programOfIntrest}
                        isProgramPage={isProgramPage}
                        title={
                          popUpData?.common_popup?.title_link?.title ||
                          popupData?.title
                        }
                        btnText={
                          popUpData?.common_popup?.title_link?.link?.label ||
                          popupData?.cta
                        }
                        onVineCrmApi={popupClosed}
                        handleStep={handleStep}
                        closePopup={closePopup}
                        preEnrollmentEnable={preEnrollmentEnable}
                        onFilledFieldsChange={handleFilledFieldsChange}
                        programOfIntrestLP={programOfIntrestLP}
                        programOfInterestMultipleOptionList={
                          programOfInterestMultipleOptionList
                        }
                        saveEvenCmsData={saveEvenCmsData}
                        saveDataOnVinecrm={saveDataOnVinecrm}
                        formFieldsSection={formFieldsSection}
                        EventTitle={EventTitle}
                    />
                    )}
                  </div>
                </div>
              ) : (
                showThankYouMessage && (
                  <div
                    className={Styles.ThankYouMessage}
                    style={{ textAlign: "center" }}
                  >
                    <Image
                      src="/assets/tick-icon.svg"
                      alt="Thank You for Reaching Out!"
                      title="Thank You for Reaching Out!"
                      className={Styles.TickIcon}
                      width={64}
                      height={64}
                    />
                    <p className={Styles.Header}>
                      {popUpData?.common_popup_thankyou_section?.title ||
                        popUpData?.thank_you_section?.title ||
                        "Thank You for Reaching Out!"}
                    </p>
                    <p className={Styles.SubHeader}>
                      {popUpData?.common_popup_thankyou_section?.description ||
                        popUpData?.thank_you_section?.description ||
                        `We’ve received your details. An academic advisor will
                    contact you shortly to discuss your journey with us. `}
                    </p>
                    {/* <button>Talk to Your Counselor</button> */}
                  </div>
                )
              )}
            </>
          )}
        </div>
      </div>
    ),
    container
  );
};

export default PopupForm;
